"use strict";

exports.__esModule = true;
exports.WALLET_TRANSACTION_TYPE = exports.WALLET_HISTORY_STATUS = exports.WALLET_CODE = exports.TRIP_TYPE = exports.TRAVELLER_ACTION_TYPES = exports.STORAGE_KEYS = exports.SORTEDBOOKING = exports.REFRESH_TOKEN_MAX_AGE = exports.REFRESH_EXPIRY_TIMER = exports.PRODUCT_TYPES = exports.PAYMENT_STATUS = exports.PAYMENT_METHODS = exports.ORDER_STATUS = exports.ORDER_PRODUCT_TYPES = exports.OLD_BOOKING_STATUS = exports.MAIN_PRODUCT_TYPES = exports.LOYALTY_METHODS = exports.HOTEL_ORDER_END_USER_STATUS = exports.GRANT_TYPES = exports.GENERIC_LOOKUP_ACTION_TYPES = exports.FLIGHT_BOOKING_STATUS = exports.ENDPOINTS = exports.BOOKING_TYPES = exports.BOOKING_STATUS = exports.BOOKING_APPEARANCE = exports.B2B = exports.AUTH_TOKEN_MAX_AGE = exports.ALL_PRODUCT_BOOKING_STATUS = exports.AD_SOLUTION_PATH = exports.ACTION_TYPES_SALES = exports.ACTION_TYPES_KYC_PREFRENCES = exports.ACTION_TYPES = exports.ACCOUNT_TYPE = exports.ACCOUNT_STATUS = exports.ACCOMMODATION_BOOKING_STATUS = void 0;
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
const ENDPOINTS = {
  USER: '/api/myaccount/v3/user/{userId}',
  ME: '/api/myaccount/v3/user/me',
  DELETE_ACCOUNT: '/api/myaccount/v3/user/delete/local/init-process',
  DELETE_ACCOUNT_VERIFY: '/api/myaccount/v3/user/delete/local',
  ORDERS_V1: '/api/hotel/order/user',
  ORDERS: '/api/myaccount/v3/order/user',
  ORDERS_V2: '/api/account/v2/order/user',
  RETRIEVE_ORDER: '/api/checkout/order?orderNumber={number}',
  GET_ORDER: '/api/checkout/order?orderNumber={orderId}',
  RETRIEVE_FLIGHTS_ORDER: '/api/checkout/order?orderNumber={number}',
  CONTACT: '/api/account/contact',
  BILLING: '/api/account/billing',
  TRAVELLER: '/api/myaccount/v3/traveller/{id}',
  TRAVELLERS: '/api/myaccount/v3/traveller',
  TRAVELLERS_V2: '/api/account/traveller',
  TRAVELLERS_V4: '/api/myaccount/v4/user/travellers',
  CREATE_TRAVELLER: '/api/myaccount/v3/traveller',
  CREATE_TRAVELLER_V4: '/api/myaccount/v4/user/travellers',
  UPDATE_TRAVELLER: '/api/myaccount/v3/traveller/{id}',
  UPDATE_TRAVELLER_V4: '/api/myaccount/v4/user/travellers/{id}',
  DELETE_TRAVELLER: '/api/myaccount/v3/traveller/{id}',
  REGISTER: '/api/myaccount/v3/user',
  LOGIN: '/api/myaccount/v3/auth/token',
  // REFRESH_TOKEN as well
  LOGOUT: '/api/myaccount/v3/auth/revoke',
  SIGN_IN_WITH_APPLE: '/api/myaccount/v3/social/login',
  // this is for both registeration and sign in
  DELETE_APPLE_ACCOUNT: '/api/myaccount/v3/user/delete/social',
  OAUTH_LOGIN: '/auth/social/{platform}',
  FORGOT_PASSWORD: '/api//myaccount/v3/password/forgot',
  RESET_PASSWORD_EMAIL: '/api/myaccount/v3/password/email/set',
  RESET_PASSWORD_PHONE: '/api/myaccount/v3/password/phone/set',
  VERIFY_RESET_PASSWORD: '/api/myaccount/v3/user/{token}/reset',
  UPDATE_REGISTRATION: '/api/myaccount/v3/user/update/registration',
  SUBSCRIBE: '/api/account/newsletter/subscribe',
  CHANGE_PASSWORD: '/api/myaccount/v3/user/{userId}/password',
  VERIFY_USER_EMAIL: '/api/myaccount/v3/email/verify',
  VERIFY_USER_PHONE: '/api/myaccount/v3/phone/verify',
  RESEND_VERIFY_EMAIL: '/api/myaccount/v3/email/send-verification',
  RESEND_VERIFY_PHONE: '/api/myaccount/v3/phone/send-verification',
  CHECK_OTP_STATUS: '/api/myaccount/v3/otp/status',
  LOYALTY_CHECK_HISTORY: '/api/loyalty/check-history',
  LOYALTY_CHECK_BALANCE: '/api/loyalty/check-balance',
  CMS_PAGE: '/api/cms/page',
  USER_LINK_ORDER: '/api/myaccount/v3/link/order',
  SUBMIT_PROMO: '/api/myaccount/v3/user/promotions',
  ORDER_PDF_URL: '/api/email-server/download-order-pdf/{orderNumber}/{orderId}',
  HOTEL_CHAINS: '/api/myaccount/v3/hotel-chains',
  INTERESTS: '/api/myaccount/v3/interests',
  SAVE_PREFRENCES: '/api/myaccount/v3/user/kyc/preferences/bulk',
  GET_PREFRENCES: '/api/myaccount/v3/user/kyc/preferences',
  GET_PREFRENCES_STATUS: '/api/myaccount/v3/user/kyc/preferences/status',
  GET_GENERIC_LOOKUP: '/api/myaccount/v3/resources/look-up',
  GET_AIRLINES: '/api/flight/resource/airline',
  GET_SALE: '/api/checkout/sale/number?number={saleNumber}&{extraParam}',
  GET_SALE_LIST: '/api/myaccount/v3/user/sales/list',
  GET_RESOURCES: '/api/static/resources',
  CREDIT_CARD: '/api/myaccount/payment-instruments',
  UPDATE_DELETE_CREDIT_CARD: '/api/myaccount/payment-instruments/{instrumentId}',
  LOYALTIES_API: '/api/myaccount/v3/loyalties/user',
  LOYALTIES_API_UPDATE_DELETE: '/api/myaccount/v3/loyalties/user/{referenceId}',
  PREFERRED_LOYALTY: '/api/myaccount/v3/user/kyc/preferences/loyalty',
  GET_ACTIVITIES_CITES: '/api/ignite/activities/cities',
  GET_HAS_EXPLORE_ACTIVITY: '/api/ignite/activities/cross-sale',
  GET_POINTS_EXCHANGE_PRODUCTS: '/api/points-exchange/product/search',
  GET_POINTS_EXCHANGE_PRODUCT: '/api/points-exchange/product/search/{productId}?source={source}&target={target}&amount={amount}&displayType={displayType}',
  GET_WALLET_CHECK_BALANCE: '/api/points-exchange/loyalty/check-balance',
  POINTS_EXCHANGE_CREATE_SALE: '/api/points-exchange/sale',
  POINTS_EXCHANGE_INIT_REDEEM: '/api/checkout/sale/{saleId}/init-redeem',
  POINTS_EXCHANGE_CHECKOUT: '/api/checkout/sale/{saleId}/checkout',
  POINTS_EXCHANGE_ALLOWED_PROVIDERS: '/api/points-exchange/providers',
  HOTEL_CROSS_SELL_ASYNC: '/api/cross-sell/hotel/search/async',
  HOTEL_CROSS_SELL_POLL: '/api/cross-sell/hotel/search/poll/{csId}?sId={sId}',
  MISC_FETCH: '/api/addon/miscellaneous/v3/order/search'
  // ??
  // SETTINGS: 'https://next-staging.almosafer.com/api/myaccount/v3/user/setting', // User Settings Details
};
exports.ENDPOINTS = ENDPOINTS;
const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_HASHING: 'md5_user',
  USER_BASE64: 'base64_user',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_EXPIRY: 'token_expires_in',
  ENIGMA_API_TOKEN: 'ENIGMA_API_TOKEN'
};
exports.STORAGE_KEYS = STORAGE_KEYS;
const AUTH_TOKEN_MAX_AGE = 14;
exports.AUTH_TOKEN_MAX_AGE = AUTH_TOKEN_MAX_AGE;
const REFRESH_TOKEN_MAX_AGE = 90;
exports.REFRESH_TOKEN_MAX_AGE = REFRESH_TOKEN_MAX_AGE;
const ACCOUNT_TYPE = {
  LOCAL: 'local',
  SOCIAL: 'social'
};
exports.ACCOUNT_TYPE = ACCOUNT_TYPE;
const ACCOUNT_STATUS = {
  ACTIVE: 'active'
};
exports.ACCOUNT_STATUS = ACCOUNT_STATUS;
const ACTION_TYPES = {
  FETCH_USER: 'FETCH_USER',
  UPDATE_USER: 'UPDATE_USER',
  SUBMIT_PROMO: 'SUBMIT_PROMO'
};
exports.ACTION_TYPES = ACTION_TYPES;
const TRAVELLER_ACTION_TYPES = {
  FETCH_TRAVELLER: 'FETCH_TRAVELLER',
  CREATE_TRAVELLER: 'CREATE_TRAVELLER',
  UPDATE_TRAVELLER: 'UPDATE_TRAVELLER',
  DELETE_TRAVELLER: 'DELETE_TRAVELLER'
};
exports.TRAVELLER_ACTION_TYPES = TRAVELLER_ACTION_TYPES;
const PRODUCT_TYPES = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  GIFTCARD: 'gift-card',
  ACTIVITY: 'activity'
};
exports.PRODUCT_TYPES = PRODUCT_TYPES;
const MAIN_PRODUCT_TYPES = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACTIVITY: 'activity'
};
exports.MAIN_PRODUCT_TYPES = MAIN_PRODUCT_TYPES;
const BOOKING_TYPES = {
  UPCOMING: 'upcoming',
  PAST: 'past'
};
exports.BOOKING_TYPES = BOOKING_TYPES;
const ACCOMMODATION_BOOKING_STATUS = {
  SUCCESS: 58,
  FAILURE: 60,
  CANCELLED: 94,
  REFUNDED: 95,
  MANUALLY_CANCELLED: 96,
  CANCEL_ON_PROCESSING: 102
};
exports.ACCOMMODATION_BOOKING_STATUS = ACCOMMODATION_BOOKING_STATUS;
const PAYMENT_STATUS = {
  AUTHORIZED: 78,
  AUTHORIZED_WITH_INSTALLMENTS: 80,
  PENDING: 71
};
exports.PAYMENT_STATUS = PAYMENT_STATUS;
const ORDER_STATUS = {
  CANCELLED: 94,
  MANUALLY_CANCELLED: 96
};
exports.ORDER_STATUS = ORDER_STATUS;
const TRIP_TYPE = {
  roundtrip: 'Roundtrip',
  oneway: 'Oneway',
  multicity: 'MultiCity'
};
exports.TRIP_TYPE = TRIP_TYPE;
const WALLET_CODE = {
  USER_NOT_ENROLLED: 8004
};
exports.WALLET_CODE = WALLET_CODE;
const WALLET_TRANSACTION_TYPE = {
  REDEEM: 'REDEEM',
  REWARD: 'REWARD',
  EXPIRED: 'EXPIRED',
  REFUND: 'RFD'
};
exports.WALLET_TRANSACTION_TYPE = WALLET_TRANSACTION_TYPE;
const WALLET_HISTORY_STATUS = {
  AVAILABLE: 'Available',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  REDEEMED: 'Redeemed',
  PENDING: 'Pending'
};
exports.WALLET_HISTORY_STATUS = WALLET_HISTORY_STATUS;
const BOOKING_APPEARANCE = {
  OFFLINE: 'offline',
  CANCELLED: 'cancelled',
  PENDING: 'payment_pending',
  CONFIRMED: 'confirmed'
};
exports.BOOKING_APPEARANCE = BOOKING_APPEARANCE;
const ALL_PRODUCT_BOOKING_STATUS = {
  IN_PROGRESS: 201,
  CONFIRMED: 200,
  CONFIRMED_PENDING_PAYMENT: 300,
  NOT_CONFIRMED: 202,
  PENDING_PAYMENT: 210,
  CANCELLED_NOT_REFUNDED: 220,
  CANCELLED_REFUNDED: 221,
  COMPLETED: 300,
  UN_MAPPED: 500,
  CANCELLED: 400
};
exports.ALL_PRODUCT_BOOKING_STATUS = ALL_PRODUCT_BOOKING_STATUS;
const BOOKING_STATUS = {
  IN_PROGRESS: 'isProgress',
  CONFIRMED: 'confirmed',
  CONFIRMED_PENDING_PAYMENT: 'confirmedPendingPayment',
  NOT_CONFIRMED: 'notConfirmed',
  PENDING_PAYMENT: 'pendingPayment',
  CANCELLED_NOT_REFUNDED: 'Cancelled & pending refund',
  CANCELLED_REFUNDED: 'cancelledRefunded',
  COMPLETED: 'completed',
  UN_MAPPED: 'un Mapped',
  CANCELLED: 'cancelled'
};
exports.BOOKING_STATUS = BOOKING_STATUS;
const ORDER_PRODUCT_TYPES = {
  VAT: 'vat',
  INSURANCE: 'insurance',
  RULE: 'rule',
  COUPON: 'coupon',
  LOYALTY: 'loyalty',
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  GIFTCARD: 'gift-card',
  ACTIVITIES: 'activity'
};
exports.ORDER_PRODUCT_TYPES = ORDER_PRODUCT_TYPES;
const LOYALTY_METHODS = {
  QITAF: 'qitaf',
  FURSAN: 'fursan',
  WALLET: 'wallet',
  MOKAFAA: 'mokafa'
};
exports.LOYALTY_METHODS = LOYALTY_METHODS;
const B2B = 'B2B';
exports.B2B = B2B;
const SORTEDBOOKING = [210, 300, 201, 200, 220, 221, 202, 500, 400];
exports.SORTEDBOOKING = SORTEDBOOKING;
const HOTEL_ORDER_END_USER_STATUS = {
  CONFIRMED: 'CONFIRMED',
  CONFIRMING_WITH_HOTEL: 'CONFIRMING_WITH_HOTEL',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  CANCELLED_PAY_NOW: 'CANCELLED_PAY_NOW',
  CANCELLED_PAY_LATER: 'CANCELLED_PAY_LATER',
  NOT_CONFIRMED: 'NOT_CONFIRMED',
  STAY_COMPLETED: 'STAY_COMPLETED'
};
exports.HOTEL_ORDER_END_USER_STATUS = HOTEL_ORDER_END_USER_STATUS;
const OLD_BOOKING_STATUS = {
  FAILURE: 91,
  CANCELLED: 94,
  SUCCESS: 58,
  PENDING: 71
};
exports.OLD_BOOKING_STATUS = OLD_BOOKING_STATUS;
const FLIGHT_BOOKING_STATUS = {
  SUCCESS: 58,
  FAILURE: 60,
  CANCELLED: 94,
  REFUNDED: 95,
  MANUALLY_CANCELLED: 96,
  CANCEL_ON_PROCESSING: 102
};
exports.FLIGHT_BOOKING_STATUS = FLIGHT_BOOKING_STATUS;
const PAYMENT_METHODS = {
  CHECKOUTCOM: 'checkoutcom',
  LOYALTY: 'loyalty',
  PAYFORT: 'payfort',
  TAJAWAL_PAY: 'tp',
  PAY_LATER: 'op',
  INSTALLMENTS: 'installments',
  FORT: 'fort',
  KNET: 'knet',
  THREE_D_SECURE: '3dsecure',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  APPLE_PAY: 'apple-pay',
  MOKAFAA: 'mokafa',
  TABBY: 'tabby',
  BANK_TRANSFER: 'bank_transfer'
};
exports.PAYMENT_METHODS = PAYMENT_METHODS;
const GRANT_TYPES = {
  PASSWORD: 'password',
  REFRESH_TOKEN: 'refresh_token'
};
exports.GRANT_TYPES = GRANT_TYPES;
const GENERIC_LOOKUP_ACTION_TYPES = {
  FETCH_GENERIC_LOOKUP: 'FETCH_GENERIC_LOOKUP'
};

// 300,000 ms => 5 minutes
exports.GENERIC_LOOKUP_ACTION_TYPES = GENERIC_LOOKUP_ACTION_TYPES;
const REFRESH_EXPIRY_TIMER = 300000;
exports.REFRESH_EXPIRY_TIMER = REFRESH_EXPIRY_TIMER;
const ACTION_TYPES_KYC_PREFRENCES = {
  FETCH_HOTEL_CHAINS: 'FETCH_HOTEL_CHAINS',
  FETCH_INTERESTS: 'FETCH_INTERESTS;',
  FETCH_FAVORITE_DESTINATION: 'FETCH_FAVORITE_DESTINATION',
  SAVE_PREFRENCES: 'SAVE_PREFRENCES',
  GET_PREFRENCES: 'GET_PREFRENCES',
  GET_PREFRENCES_STATUS: 'GET_PREFRENCES_STATUS',
  FETCH_AIRLINES: 'FETCH_AIRLINES'
};
exports.ACTION_TYPES_KYC_PREFRENCES = ACTION_TYPES_KYC_PREFRENCES;
const ACTION_TYPES_SALES = {
  FETCH_UPCOMING_SALES_LIST: 'FETCH_UPCOMING_SALES_LIST',
  FETCH_PAST_SALES_LIST: 'FETCH_PAST_SALES_LIST'
};
exports.ACTION_TYPES_SALES = ACTION_TYPES_SALES;
const AD_SOLUTION_PATH = {
  MWEB: '/api/ad-butler',
  DESKTOP: '/api/ad-butler',
  MWEB_PROXY_PATH: `/api/ad-butler${_constants.HOSTS.AD_SOLUTION.PATHNAME}`,
  DESKTOP_PROXY_PATH: `/api/ad-butler${_constants.HOSTS.AD_SOLUTION.PATHNAME}`
};
exports.AD_SOLUTION_PATH = AD_SOLUTION_PATH;